export const url = {
  facebook: "https://www.facebook.com/jungleminds",
  instagram: "http://www.instagram.com/jungleminds",
  twitter: "http://www.twitter.com/jungleminds",
  youtube: "",
  linkedin: "https://www.linkedin.com/company/jungle-minds",
}
